<ngx-ui-loader></ngx-ui-loader>
<section>
    <div class="tab-content pt-5 pb-5" style="display: block;">
        <div class="container mb-5">
            <header>
                <h3 class="header-title">{{language.ap_head}}</h3>
            </header>
            <div class="px-0 col-12">
                <div *ngIf="assetProfileStep1" class="card-body">
                    <div class="card row p-5">
                        <div class="row" style="justify-content: space-between;">
                            <div class="col-sm-4 col-md-8 col-lg-10"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <h4>{{language.ap_Head_HNW_UHNW}}</h4>
                            </div>
                        </div>
                        <div class="row" style="font-size: 17px;">
                            <div class="col-sm-4 col-md-8 col-lg-12" style="align-self: flex-end; padding-bottom: 5px;">
                                <p>{{language.ap_Assessmnet_date}}: {{DocDateHNW_UHNW}} </p>
                            </div>
                            <div class="col-sm-4 col-md-8 col-lg-12" style="align-self: flex-end; padding-bottom: 5px;">
                                <p>{{language.ap_Due_date}}: {{EndDateHNW_UHNW}}</p>
                            </div>
                            <div class="col-sm-4 col-md-8 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <p>{{language.ap_Status}}: {{StatusHNW_UHNW}} </p>
                            </div>
                            <div class="col-sm-4 col-md-8 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <button *ngIf="btnPreviewHNW_UHNW" type="button" id="btn_preview" class="btn button-custom btn-primary btn-md mr-2"
                                    (click)="previewProfile('HNW')">
                                    {{language.ap_btn_Preview}}
                                </button>
                                <button type="button" id="btn01" class="btn button-custom btn-warning btn-md mr-2"
                                    (click)="addProfile('HNW')">
                                    {{btnAdd_Text_HNW_UHNW}}
                                </button>
                            </div>
                        </div>
                        <div class="row" style="justify-content: space-between;">
                            <div class="col-sm-4 col-md-8 col-lg-10"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <h4>{{language.ap_Head_Angel}}</h4>
                            </div>
                        </div>
                        <div class="row" style="font-size: 17px;">
                            <div class="col-sm-4 col-md-8 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <p>{{language.ap_Assessmnet_date}}: {{DocDateAngel}} </p>
                            </div>
                            <div class="col-sm-4 col-md-8 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <p>{{language.ap_Due_date}}: {{EndDateAngel}} </p>
                            </div>
                            <div class="col-sm-4 col-md-8 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <p>{{language.ap_Status}}: {{StatusAngel}} </p>
                            </div>
                            <div class="col-sm-4 col-md-8 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <button *ngIf="btnPreviewAngel"  type="button" id="btn_preview" class="btn button-custom btn-primary btn-md mr-2"
                                    (click)="previewProfile('Angel')">
                                    {{language.ap_btn_Preview}}
                                </button>
                                <button type="button" id="btn01" class="btn button-custom btn-warning btn-md mr-2"
                                    (click)="addProfile('Angel')">
                                    {{btnAdd_Text_Angel}}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                <div *ngIf="assetProfileStep2 && isPageHNW" class="card-body">
                    <div class="card row p-5">
                        <div class="row col-sm-6 col-md-12 col-lg-12 pb-2 p-0" style="justify-content: center;">
                            <label class="radio-inline icheck-label needsclick pr-2">
                                <app-radio name="TypeNetWorth" id="type-hnw" (click)="changType('hnw')"></app-radio>
                                <span style="margin-left: 2.7rem; font-size: 1.4rem;">{{language.ap_HNW}}</span>
                            </label>
                            <label class="radio-inline icheck-label needsclick">
                                <app-radio name="TypeNetWorth" id="type-uhnw" (click)="changType('uhnw')"></app-radio>
                                <span style="margin-left: 2.7rem; font-size: 1.4rem;">{{language.ap_UHNW}}</span>
                            </label>
                        </div>

                        <div class="row" *ngFor="let item of ArrayNW" style="justify-content: space-between;">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="padding-bottom: 10px;">
                                <h4 class="pb-2">{{language_flag === 'th' ? item.QuestionDescTh : item.QuestionDescEn}}
                                </h4>
                                <div style="font-size: 17px; margin-left: 1.7rem;" class="item2_Text">
                                    <section class="group-section" *ngFor="let item2 of item.SupQuestions">
                                        <ul class="list-form list-unstyled row checkbox--section">
                                            <li class="col-sm-12 col-md-12 col-lg-12">
                                                <label class="checkbox-inline icheck-label needsclick"
                                                    style="margin-left: 1.7rem;">



                                                    <span *ngIf="item2.sups.length > 0; else elseItem2"
                                                        style="font-weight: bold;">{{language_flag === 'th' ?
                                                        item2.DescTh : item2.DescEn}}</span>
                                                    <ng-template #elseItem2>
                                                        <span>{{language_flag === 'th' ? item2.DescTh :
                                                            item2.DescEn}}</span>
                                                    </ng-template>
                                                    <app-checkbox *ngIf="item2.sups.length == 0"
                                                        (returnCheckboxValue)="addAnswerUltraHNW(item2.SubQuestionId)"></app-checkbox>
                                                </label>

                                            </li>

                                            <li class="col-md-12 col-lg-12 pt-1" *ngFor="let item3 of item2.sups">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                        <label class="checkbox-inline icheck-label needsclick"
                                                            style="margin-left: 1.7rem;">
                                                            {{language_flag === 'th' ? item3.DescTh : item3.DescEn}}
                                                            <app-checkbox
                                                                (returnCheckboxValue)="addAnswerUltraHNW(item3.SubQuestionId)"></app-checkbox>
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center mt-3">
                        <div class="col-sm-2 col-md-4 col-lg-4" *ngIf="isSubmit">
                            <button type="button" id="btn01" class="btn btn-primary btn-md btn-block"
                                (click)="submitAssetProfile()">
                                {{language.ap_btn_save}}
                            </button>
                        </div>
                        <div class="col-sm-2 col-md-4 col-lg-4">
                            <button type="button" id="btn01" class="btn btn-primary btn-md btn-block"
                                (click)="cancelProfile()">
                                {{language.ap_btn_back}}
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="assetProfileStep2 && isPageAngel" class="card-body">
                    <div class="card row p-5">
                        <div class="col-sm-6 col-md-12 col-lg-12 pb-2 p-0">
                            <label class="radio-inline icheck-label needsclick pr-2">
                                <h3 style="color: black;">{{isAngel === true ? QuestionnaireAngelStr:QuestionnaireStr}}
                                </h3>
                            </label>
                        </div>

                        <div class="row" *ngFor="let item of myArrayAngel" style="justify-content: space-between;">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12"
                                style="align-self: flex-end; padding-bottom: 10px;">
                                <h4>{{language_flag === 'th' ? item.QuestionDescTh : item.QuestionDescEn}}</h4>
                                <div style="font-size: 17px; margin-left: 1.7rem; " class="item2_Text">
                                    <section class="group-section" *ngFor="let item2 of item.SupQuestions">
                                        <ul class="list-form list-unstyled row checkbox--section">
                                            <li class="col-sm-12 col-md-12 col-lg-12">
                                                <label class="checkbox-inline icheck-label needsclick"
                                                    style="margin-left: 1.7rem;">

                                                    <span *ngIf="item2.sups.length > 0; else elseItem2"
                                                        style="font-weight: bold;">{{language_flag === 'th' ?
                                                        item2.DescTh : item2.DescEn}}</span>
                                                    <ng-template #elseItem2>
                                                        <span>{{language_flag === 'th' ? item2.DescTh :
                                                            item2.DescEn}}</span>
                                                    </ng-template>
                                                    <app-checkbox *ngIf="item2.sups.length == 0"
                                                        (returnCheckboxValue)="addAnswerUltraHNW(item2.SubQuestionId)"></app-checkbox>
                                                </label>

                                            </li>

                                            <li class="col-sm-12 col-md-12 col-lg-12 pt-1"
                                                *ngFor="let item3 of item2.sups">
                                                <div class="row">
                                                    <div class="col-md-12 col-lg-12">
                                                        <label class="checkbox-inline icheck-label needsclick"
                                                            style="margin-left: 1.7rem;">
                                                            {{language_flag === 'th' ? item3.DescTh : item3.DescEn}}
                                                            <app-checkbox
                                                                (returnCheckboxValue)="addAnswerUltraHNW(item3.SubQuestionId)"></app-checkbox>
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row justify-content-center mt-3">
                        <div class="col-sm-2 col-md-4 col-lg-4">
                            <button type="button" id="btn01" class="btn btn-primary btn-md btn-block"
                                (click)="submitAssetProfile()">
                                {{language.ap_btn_save}}
                            </button>
                        </div>
                        <div class="col-sm-2 col-md-4 col-lg-4">
                            <button type="button" id="btn01" class="btn btn-primary btn-md btn-block"
                                (click)="cancelProfile()">
                                {{language.ap_btn_back}}
                            </button>
                        </div>
                    </div>
                </div>

                <div *ngIf="assetProfileStep_Preview" class="card-body">
                    <div class="card row p-5">
                        <div class="col-sm-6 col-md-12 col-lg-12 pb-2 p-0">
                            <label class="radio-inline icheck-label needsclick pr-2">
                                <h3 style="color: black;">{{isAngel === true ? QuestionnaireAngelStr:QuestionnaireStr}}
                                </h3>
                            </label>
                        </div>

                        <div class="row" *ngFor="let item of ArrayNW" style="justify-content: space-between;">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="padding-bottom: 10px;">
                                <h4 class="pb-2">{{language_flag === 'th' ? item.QuestionDescTh : item.QuestionDescEn}}
                                </h4>
                                <div style="font-size: 17px; margin-left: 1.7rem;" class="item2_Text">
                                    <section class="group-section" *ngFor="let item2 of item.SupQuestions">
                                        <ul class="list-form list-unstyled row checkbox--section">
                                            <li class="col-sm-12 col-md-12 col-lg-12">
                                                <label class="checkbox-inline icheck-label needsclick"
                                                    style="margin-left: 1.7rem;">



                                                    <span *ngIf="item2.sups.length > 0; else elseItem2"
                                                        style="font-weight: bold;">{{language_flag === 'th' ?
                                                        item2.DescTh : item2.DescEn}}</span>
                                                    <ng-template #elseItem2>
                                                        <span>{{language_flag === 'th' ? item2.DescTh :
                                                            item2.DescEn}}</span>
                                                    </ng-template>
                                                    <app-checkbox *ngIf="item2.sups.length == 0"
                                                        (returnCheckboxValue)="addAnswerUltraHNW(item2.SubQuestionId)"
                                                        [id]="'checkbox_' + item2.SubQuestionId"
                                                        [class]="'checkmark' + ' clDisable'"></app-checkbox>
                                                </label>

                                            </li>

                                            <li class="col-md-12 col-lg-12 pt-1" *ngFor="let item3 of item2.sups">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                        <label class="checkbox-inline icheck-label needsclick"
                                                            style="margin-left: 1.7rem;">
                                                            {{language_flag === 'th' ? item3.DescTh : item3.DescEn}}
                                                            <app-checkbox
                                                                (returnCheckboxValue)="addAnswerUltraHNW(item3.SubQuestionId)"
                                                                [class]="'checkmark' + ' clDisable'"
                                                                [id]="'checkbox_' + item3.SubQuestionId"></app-checkbox>
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center mt-3">
                        <div class="col-sm-2 col-md-4 col-lg-4" *ngIf="isSubmit">
                            <button type="button" id="btn01" class="btn btn-primary btn-md btn-block"
                                (click)="submitAssetProfile()">
                                {{language.ap_btn_save}}
                            </button>
                        </div>
                        <div class="col-sm-2 col-md-4 col-lg-4">
                            <button type="button" id="btn01" class="btn btn-primary btn-md btn-block"
                                (click)="cancelProfile()">
                                {{language.ap_btn_back}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="assetProfileStep1" class="col-sm-2 col-md-4 col-lg-4 pr-0 pl-1">
                <button type="button" id="" class="btn btn-primary btn-md btn-block" (click)="previouEservice()">
                    {{language.ap_btn_back}}
                </button>
            </div>
        </div>
    </div>
</section>

<div id="warningModalConfirm" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">แจ้งเตือน</span></h4>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body" tabindex="4" style="line-height: 1.6;">
                    <p>{{language.ap_popup_confirm}}</p>
                </div>
            </section>
            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.tax_confirm}}" size="lg" (click)="userComfirm()"></app-button>
                <app-button text="{{language.tax_cancel}}" size="lg" (click)="userCancel()"></app-button>
            </div>
        </div>
    </div>
</div>